module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_9005.55125698.png";